import _ from 'lodash';

const podstawaPrawnaOld = {
  'Ustawa z dnia 27 marca 2003 r. o planowaniu i zagospodarowaniu przestrzennym.':
  'http://isap.sejm.gov.pl/DetailsServlet?id=WDU20030800717',
  'Ustawa z dnia 16 listopada 2006 r. o opłacie skarbowej.':
  'http://isap.sejm.gov.pl/DetailsServlet?id=WDU20062251635',
  'Ustawa z dnia 6 września 2001 r. o dostępie do informacji publicznej.':
  'http://isap.sejm.gov.pl/DetailsServlet?id=WDU20011121198',
  'Ustawa z dnia 14 czerwca 1960 r. Kodeks postępowania administracyjnego.':
  'http://isap.sejm.gov.pl/DetailsServlet?id=WDU19600300168',
};

const podstawaPrawna = [
  'Ustawa z dnia 27 marca 2003 r. o planowaniu i zagospodarowaniu przestrzennym.',
  'Ustawa z dnia 16 listopada 2006 r. o opłacie skarbowej.',
  'Ustawa z dnia 6 września 2001 r. o dostępie do informacji publicznej.',
  'Ustawa z dnia 14 czerwca 1960 r. Kodeks postępowania administracyjnego.',
];


const podstawaPrawnaWypisIWyrysZMpzp = [
  'Ustawa z dnia 27 marca 2003 r.o planowaniu i zagospodarowaniu przestrzennym (Dz. U. z 2020 r., poz. 293 z późn. zm., Art.30, ust.1)',
  'Ustawa z dnia 16 listopada 2006 roku o opłacie skarbowej (Dz. U. z 2020 r., poz. 1546 z późn. zm., Art.1, ust.1, pkt.1, lit.a)',
  'Ustawa z dnia 14 czerwca 1960r. Kodeks postępowania administracyjnego (Dz. U. z 2021 r., poz. 735 z późn. zm., Art.35)',
];

const podstawaUsuniecieDrzew = [
  'Ustawa z dnia 16 kwietnia 2004r.o ochronie przyrody (Dz. U. z 2020 r., poz. 55)',
  'Ustawa z dnia 14 czerwca 1960r. Kodeks postępowania administracyjnego (Dz. U. z 2021 r., poz. 735 z późn. zm.)',
  'Ustawa z dnia 16 listopada 2006 roku o opłacie skarbowej (Dz. U. z 2020 r., poz. 1546 z późn. zm.)',
];

const podstawaPrawnaZgloszenieUwagWnioskowMPZPStudium = [
  'Ustawa z dnia 27 marca 2003 r.o planowaniu i zagospodarowaniu przestrzennym (Dz. U. z 2020 r., poz. 293 z późn. zm., Art.30, ust.1)',
  'Ustawa z dnia 14 czerwca 1960r. Kodeks postępowania administracyjnego (Dz. U. z 2021 r., poz. 735 z późn. zm., Art.35)',
];
const trybOdwolawczy = 'Jeśli urząd nie załatwi Twojej sprawy w terminie to możesz złożyć zażalenie. Złóż je do samorządowego kolegium odwoławczego. Reguluje to art. 37 § 1 k.p.a.';
const czas14dni = 'Urząd ma 14 dni na wydanie wypisu i wyrysu – zgodnie z art. 13 ust. 1 ustawy z dnia 6 września 2001 r. o dostępie do informacji publicznej.';

export const Sprawy = {
  ZaswiadczenieMPZP: {
    title: 'Wniosek o wydanie zaświadczenia o przeznaczeniu w miejscowym planie zagospodarowania przestrzennego działki. ',
    dotyczy: 'Osoby ubiegające się o wydanie zaświadczenia o przeznaczeniu terenu w miejscowym planie zagospodarowania przestrzennego',
    czas: 'Do 7 dni',
    dokumenty: [
      'Wniosek o wydanie zaświadczenia o przeznaczeniu terenu w miejscowym planie zagospodarowania przestrzennego',
      'Kserokopia mapy ewidencyjnej gruntów z zaznaczonym terenem, o którym mowa we wniosku',
      'Potwierdzenie wniesienia opłaty skarbowej'],
    oplaty: ['17 zł'],
    tryb: 'Nie dotyczy',
    podstawa: podstawaPrawnaWypisIWyrysZMpzp,
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: 'Wydanie zaświadczenia o przeznaczeniu terenu w planie miejscowym',
    etapy: [
      '1. Złożenie wniosku',
      '2. Weryfikacja złożonego wniosku',
      '3. Wydanie zaświadczenia',
    ],
    poziom_uwierzytelniania: ['Podpis kwalifikowany', 'Profil zaufany'],
    logowanie: 'TAK',
  },
  ZgloszenieUwagWnioskowMPZPStudium: {
    title: 'Zgłoszenie wniosku/uwag do projektu Miejscowego Planu Zagospodarowania Przestrzennego i Studium Uwarunkowań i Kierunków Zagospodarowania Przestrzennego',
    dotyczy: 'Wnioski i uwagi może wnieść każdy, kto kwestionuje ustalenia przyjęte w projekcie miejscowego planu zagospodarowania przestrzennego bądź w projekcie studium uwarunkowań i kierunków zagospodarowania przestrzennego, wyłożonym do publicznego wglądu.',
    czas: 'Uzależniony od prowadzonej procedury planistycznej',
    dokumenty: [
      'Przedkładane wnioski i uwagi powinny zawierać:',
      '1. imię i nazwisko lub nazwę wnioskodawcy oraz jego adres',
      '2. przedmiot i zakres oczekiwanych rozwiązań i ustaleń planu',
      '3. określenie nieruchomości (lub opis terenów), których dotyczy wniosek',
      '4. kserokopię lub wyrys z aktualnej mapy ewidencyjnej lub zasadniczej w zakresie dotyczącym nieruchomości, której dotyczy wniosek.',
      'Wskazane jest określenie, czy wnioskodawca posiada tytuł prawny do terenu objętego wnioskiem.',
    ],
    oplaty: ['Brak opłat'],
    tryb: 'Nie dotyczy',
    podstawa: podstawaPrawnaZgloszenieUwagWnioskowMPZPStudium,
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: 'Przyjęcie wniosków i uwag do sporządzanych miejscowych planów zagospodarowania przestrzennego oraz studium uwarunkowań i kierunków zagospodarowania przestrzennego',
    etapy: [
      '1. Złożenie wniosku',
      '2. Weryfikacja złożonego wniosku',
      '3. Ewentualna aktualizacja/modyfikacja miejscowych planów zagospodarowania przestrzennego',
    ],
    poziom_uwierzytelniania: ['Podpis kwalifikowany', 'Profil zaufany'],
    logowanie: 'Logowanie wymagane jest z poziomu portalu "Partycypacja"',
  },
  WypisIWyrysZeStudium: {
    title: 'Wniosek o wydanie wypisu i wyrysu ze studium uwarunkowań i kierunków zagospodarowania przestrzennego.',
    dotyczy: 'Osoby fizyczne i osoby prawne ubiegające się o uzyskanie wypisu i wyrysu ze studium uwarunkowań i kierunków zagospodarowania przestrzennego.',
    czas: czas14dni,
    dokumenty: ['Wniosek o wydanie wypisu i wyrysu ze studium uwarunkowań i kierunków zagospodarowania przestrzennego',
      'Dowód uiszczenia opłaty skarbowej'],
    oplaty: ['Opłata od wypisu: do 5 stron – 30 zł, powyżej 5 stron – 50 zł.',
      'Za każdą wchodzącą w skład wyrysu pełną lub rozpoczętą część odpowiadającą stronie formatu A4 - 20 zł',
      'Nie więcej niż 200 zł'],
    tryb: trybOdwolawczy,
    podstawa: podstawaPrawna,
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  WypisIWyrysZMpzp: {
    title: 'Wniosek o wydanie wypisu i wyrysu z miejscowego planu zagospodarowania przestrzennego',
    dotyczy: 'Wszystkich ubiegających się o wydanie wypisu i wyrysu z projektu miejscowego planu /zmiany planu/ zagospodarowania przestrzennego',
    czas: czas14dni,
    dokumenty: ['Wypełniony wniosek o wydanie wypisu i wyrysu z miejscowego planu zagospodarowania przestrzennego',
      'Dowód uiszczenia opłaty skarbowej'],
    oplaty: ['Opłata od wypisu: do 5 stron – 30 zł, powyżej 5 stron – 50 zł.',
      'Za każdą wchodzącą w skład wyrysu pełną lub rozpoczętą część odpowiadającą stronie formatu A4 - 20 zł',
      'Nie więcej niż 200 zł'],
    tryb: 'Nie dotyczy',
    podstawa: podstawaPrawnaWypisIWyrysZMpzp,
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: 'Wydanie wypisu i wyrysu',
    etapy: ['1. Wypełnienie wniosku', '2. Weryfikacja wniosku', '3. Udzielenie odpowiedzi.'],
    poziom_uwierzytelniania: ['Podpis kwalifikowany', 'Profil zaufany'],
    logowanie: 'TAK',
  },
  NrIPowDzialkiInfo: {
    title: 'Pozyskiwanie informacji o numerach działek i ich powierzchniach.',
    dotyczy: 'Osoby fizyczne i osoby prawne zainteresowane uzyskaniem informacji o numerach działek i ich powierzchni.',
    czas: 'Nie określono.',
    dokumenty: ['Nie wymaga się żadnych dokumentów.'],
    oplaty: ['Nie ponosi się opłat.'],
    tryb: 'Nie określono.',
    podstawa: _.omit(podstawaPrawna, 'Ustawa z dnia 16 listopada 2006 r. o opłacie skarbowej.',
      'Ustawa z dnia 14 czerwca 1960 r. Kodeks postępowania administracyjnego.'),
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'NIE',
  },
  WlasnoscDzialkiInfo: {
    title: 'Pozyskiwanie informacji o właścicielach/własności działek.',
    dotyczy: 'Osoby fizyczne i osoby prawne zainteresowane uzyskaniem informacji o właścicielach/własności działek.',
    czas: 'Nie określono.',
    dokumenty: ['Nie wymaga się żadnych dokumentów.'],
    oplaty: ['Nie ponosi się opłat.'],
    tryb: 'Nie określono.',
    podstawa: _.omit(podstawaPrawna, 'Ustawa z dnia 16 listopada 2006 r. o opłacie skarbowej.',
      'Ustawa z dnia 14 czerwca 1960 r. Kodeks postępowania administracyjnego.'),
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'NIE',
  },
  ZagospDzialkiInfo: {
    title: 'Sprawdzenie sposobu zagospodarowania poszczególnych działek.',
    dotyczy: 'Osoby fizyczne i osoby prawne zainteresowane uzyskaniem informacji o zagospodarowaniu poszczególnych działek.',
    czas: 'Nie określono.',
    dokumenty: ['Nie wymaga się żadnych dokumentów.'],
    oplaty: ['Nie ponosi się opłat.'],
    tryb: 'Nie określono.',
    podstawa: _.omit(podstawaPrawna, 'Ustawa z dnia 16 listopada 2006 r. o opłacie skarbowej.',
      'Ustawa z dnia 14 czerwca 1960 r. Kodeks postępowania administracyjnego.'),
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'NIE',
  },
  PrzebiegDrogiInfo: {
    title: 'Pozyskanie informacji o przebiegu i numeracji dróg gminnych. ',
    dotyczy: 'Osoby fizyczne i osoby prawne zainteresowane uzyskaniem informacji o przebiegu i numeracji dróg gminnych.',
    czas: 'Nie określono.',
    dokumenty: ['Nie wymaga się żadnych dokumentów.'],
    oplaty: ['Nie ponosi się opłat.'],
    tryb: 'Nie określono.',
    podstawa: _.omit(podstawaPrawna, 'Ustawa z dnia 16 listopada 2006 r. o opłacie skarbowej.',
      'Ustawa z dnia 14 czerwca 1960 r. Kodeks postępowania administracyjnego.'),
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'NIE',
  },
  ZimoweUtrzymanieDrog: {
    title: 'Pozyskanie informacji o zimowym utrzymaniu dróg.',
    dotyczy: 'Osoby fizyczne i osoby prawne zainteresowane uzyskaniem informacji o zimowym utrzymaniu dróg.',
    czas: 'Nie określono.',
    dokumenty: ['Nie wymaga się żadnych dokumentów.'],
    oplaty: ['Nie ponosi się opłat.'],
    tryb: 'Nie określono.',
    podstawa: _.omit(podstawaPrawna, 'Ustawa z dnia 16 listopada 2006 r. o opłacie skarbowej.',
      'Ustawa z dnia 14 czerwca 1960 r. Kodeks postępowania administracyjnego.'),
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'NIE',
  },
  PobierzWMSiWFS: {
    title: 'Usługa pobrania WMS i WFS.',
    dotyczy: 'Osoby fizyczne i osoby prawne zainteresowane uzyskaniem dostępu do usług WMS i WFS.',
    czas: 'Nie określono.',
    dokumenty: ['Nie wymaga się żadnych dokumentów.'],
    oplaty: ['Nie ponosi się opłat.'],
    tryb: 'Nie określono.',
    podstawa: _.assign(_.omit(podstawaPrawna, 'Ustawa z dnia 16 listopada 2006 r. o opłacie skarbowej.',
      'Ustawa z dnia 14 czerwca 1960 r. Kodeks postępowania administracyjnego.'),
      { 'Ustawa z dnia 4 marca 2010 r. o infrastrukturze informacji przestrzennej.': 'http://isap.sejm.gov.pl/DetailsServlet?id=WDU20100760489' }),
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'NIE',
  },
  PobierzWFSiWMS: {
    title: 'Usługa pobrania WFS i WMS.',
    dotyczy:'Osoby fizyczne i osoby prawne zainteresowane uzyskaniem dostępu do usług WMS i WFS.',
    czas: 'Nie określono.',
    dokumenty: ['Nie wymaga się żadnych dokumentów.'],
    oplaty: ['Nie ponosi się opłat.'],
    tryb: 'Nie określono.',
    podstawa: _.assign(_.omit(podstawaPrawna, 'Ustawa z dnia 16 listopada 2006 r. o opłacie skarbowej.',
      'Ustawa z dnia 14 czerwca 1960 r. Kodeks postępowania administracyjnego.'),
      { 'Ustawa z dnia 4 marca 2010 r. o infrastrukturze informacji przestrzennej.': 'http://isap.sejm.gov.pl/DetailsServlet?id=WDU20100760489' }),
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'NIE',
  },
  UproszczWypis: {
    title: 'Wniosek o uproszczony wypis z miejscowego planu zagospodarowania przestrzennego',
    dotyczy: 'Osoby fizyczne i osoby prawne ubiegające się o uzyskanie uproszczonego wypisu z miejscowego planu zagospodarowania przestrzennego.',
    czas:  'Urząd ma 14 dni na wydanie uproszczonego wypisu – zgodnie z art. 13 ust. 1 ustawy z dnia 6 września 2001 r. o dostępie do informacji publicznej.',
    dokumenty: ['Wniosek o wydanie uproszczonego wypisu z miejscowego planu zagospodarowania przestrzennego.',
      'Dowód uiszczenia opłaty skarbowej.'],
    oplaty: ['Opłata od wypisu: do 5 stron – 30 zł, powyżej 5 stron – 50 zł.',
      'Za każdą wchodzącą w skład wyrysu pełną lub rozpoczętą część odpowiadającą stronie formatu A4 - 20 zł',
      'Nie więcej niż 200 zł'],
    tryb: trybOdwolawczy,
    podstawa: podstawaPrawna,
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  ZgodnoscMPZP: {
    title: 'Wniosek o zaświadczenie o zgodności zmiany sposobu użytkowania obiektu budowlanego z ustaleniami miejscowego planu zagospodarowania przestrzennego',
    dotyczy: 'Osoby fizyczne i osoby prawne ubiegające się o zaświadczenie o zgodności zmiany sposobu użytkowania obiektu budowlanego z ustaleniami miejscowego planu zagospodarowania przestrzennego.',
    czas: 'Nie określono.',
    dokumenty: ['Wniosek o zaświadczenie o zgodności zmiany sposobu użytkowania obiektu budowlanego z ustaleniami miejscowego planu zagospodarowania przestrzennego', 'Dowód uiszczenia opłaty skarbowej.'],
    oplaty: ['17 zł'],
    tryb: 'Nie określono.',
    podstawa: podstawaPrawna,
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  WniosekUproszczonyWypis: {
    title: 'Wniosek o uproszczony wypis z miejscowego planu zagospodarowania przestrzennego',
    dotyczy: 'Osoby fizyczne i osoby prawne ubiegające się o uproszczony wypis z miejscowego planu zagospodarowania przestrzennego.',
    czas: 'Nie określono.',
    dokumenty: ['Wniosek o uproszczony wypis z miejscowego planu zagospodarowania przestrzennego'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: podstawaPrawna,
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  ZaswiadczenieFormOchrony: {
    title: 'Wniosek o wydanie zaświadczenia o lokalizacji na danej nieruchomości form ochrony przyrody',
    dotyczy: 'Osoby fizyczne i osoby prawne ubiegające się o zaświadzczenie o lokalizacji na danej nieruchomości form ochrony przyrody.',
    czas: 'Nie określono.',
    dokumenty: ['Dowód uiszczenia opłaty skarbowej.'],
    oplaty: ['17 zł'],
    tryb: 'Nie określono.',
    podstawa: podstawaPrawna,
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  ZaswiadczenieStrefOchronnych: {
    title: 'Wniosek o wydanie zaświadczenia o lokalizacji na danej nieruchomości stref ochronnych',
    dotyczy: 'Osoby fizyczne i osoby prawne ubiegające się o zaświadzczenie o lokalizacji na danej nieruchomości stref ochronnych.',
    czas: 'Nie określono.',
    dokumenty: ['Dowód uiszczenia opłaty skarbowej.'],
    oplaty: ['17 zł'],
    tryb: 'Nie określono.',
    podstawa: podstawaPrawna,
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  OpiniaPodzialu: {
    title: 'Wniosek o opinię w sprawie zgodności podziału nieruchomości z ustaleniami MPZP',
    dotyczy: 'Osoby fizyczne i osoby prawne ubiegające się o opinię w sprawie zgodności podziału nieruchomości z ustaleniami MPZP.',
    czas: 'Nie określono.',
    dokumenty: ['Wniosek o opinię w sprawie zgodności podziału nieruchomości z ustaleniami MPZP'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: podstawaPrawna,
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  WniosekPomnikPrzyrody: {
    title: 'Wniosek o ustalenie pomnika ochrony przyrody',
    dotyczy: 'Osoby fizyczne i osoby prawne ubiegające się o ustalenie pomnika ochrony przyrody.',
    czas: 'Nie określono.',
    dokumenty: ['Wniosek o ustalenie pomnika ochrony przyrody'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: podstawaPrawna,
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  SprzedazNieruchomosci: {
    title: 'Wniosek o sprzedaż nieruchomości lub jej części',
    dotyczy: 'Osoby fizyczne i osoby prawne ubiegające się o kupno nieruchomości lub jej części.',
    czas: 'Nie określono.',
    dokumenty: ['Wniosek o sprzedaż nieruchomości lub jej części'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  ZmianaMPZP: {
    title: 'Wniosek o zmianę miejscowego planu zagospodarowania przestrzennego',
    dotyczy: 'Osoby fizyczne i osoby prawne ubiegające się o zmianę miejscowego planu zagospodarowania przestrzennego.',
    czas: 'Nie określono.',
    dokumenty: ['Wniosek o zmianę miejscowego planu zagospodarowania przestrzennego'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: podstawaPrawna,
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  DzierzawaNieruchomosci: {
    title: 'Wniosek o dzierżawę nieruchomości lub jej części',
    dotyczy: 'Osoby fizyczne i osoby prawne ubiegające się o dzierżawę nieruchomości lub jej części',
    czas: 'Nie określono.',
    dokumenty: ['Wniosek o dzierżawę nieruchomości lub jej części'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    podstawa: [],
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  UwagiProceduryPlanistycznej: {
    title: 'Uwagi do procedury planistycznej',
    dotyczy: 'Osoby fizyczne i osoby prawne składające uwagi do procedury planistycznej',
    czas: 'Nie określono.',
    dokumenty: ['Uwaga do procedury planistycznej'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    podstawa: [],
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  UwagiMPZP: {
    title: 'Uwagi do projektu miejscowego planu zagospodarowania przestrzennego w okresie jego wyłożenia do publicznego wglądu',
    dotyczy: 'Osoby fizyczne i osoby prawne składające uwagi do projektu miejscowego planu zagospodarowania przestrzennego w okresie jego wyłożenia do publicznego wglądu.',
    czas: 'Nie określono.',
    dokumenty: ['Uwagi do projektu miejscowego planu zagospodarowania przestrzennego w okresie jego wyłożenia do publicznego wglądu'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  DecyzjaSrodowiskowa: {
    title: 'Wniosek o wydanie decyzji o środowiskowych uwarunkowaniach',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Dowód uiszczenia opłaty skarbowej.'],
    oplaty: ['205 zł'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  DecyzjeULICP: {
    title: 'Wniosek o wydanie decyzji o ustaleniu lokalizacji inwestycji celu publicznego',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Dowód uiszczenia opłaty skarbowej.'],
    oplaty: ['107 zł'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  DecyzjeWZ: {
    title: 'Wniosek o wydanie decyzji o warunkach zabudowy',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Dowód uiszczenia opłaty skarbowej.'],
    oplaty: ['107 zł'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  OplataPlanistyczna: {
    title: 'Wniosek o ustalenie opłaty planistycznej przed zbyciem nieruchomości',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  PrzeniesienieDecyzjiOWarunkachZabudowy: {
    title: 'Wniosek o przeniesienie decyzji o warunkach zabudowy na rzecz innej osoby',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Dowód uiszczenia opłaty skarbowej.'],
    oplaty: ['56 zł'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  PrzeniesienieSrodowiskowychUwarunkowan: {
    title: 'Wniosek o przeniesienie decyzji o środowiskowych uwarunkowaniach',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  SporzadzenieMPZP: {
    title: 'Wniosek o sporządzenie miejscowego planu zagospodarowania przestrzennego',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  UstalenieNumeruPorzadkowego: {
    title: 'Wniosek o ustalenie numeru porządkowego budynku',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  UsuniecieDrzew: {
    title: 'Wniosek o wydanie zezwolenia na usunięcie drzew lub krzewów',
    dotyczy: 'Osoby prawne, jednostki organizacyjne oraz osoby fizyczne.',
    czas: 'Do 30 dni, Do 60 dni - w przypadku wniosku o wydanie zezwolenia na usunięcie drzewa z terenu pasa drogowego drogi publicznej',
    dokumenty: [
      '- Oświadczenie o udostępnieniu informacji, o której mowa w art. 83 ust. 4 ustawy o ochronie przyrody (dotyczy spółdzielni mieszkaniowych i wspólnot mieszkaniowych).',
      '- Dokument potwierdzający udzielenie pełnomocnictwa, gdy wnioskodawca działa poprzez pełnomocnika.',
      '- Zezwolenie w stosunku do gatunków chronionych na czynności podlegające zakazom określonym w art. 51 ust. 1 pkt 1–4 i 10 oraz w art. 52 ust. 1 pkt 1, 3, 7, 8, 12, 13 i 15 ustawy o ochronie przyrody, jeżeli zostało wydane',
      '- Zgoda właściciela terenu, jeżeli wnioskodawca nie jest jej właścicielem.',
      '- Oświadczenie o posiadanym tytule prawnym władania nieruchomością.',
      '- Decyzja o środowiskowych uwarunkowaniach albo postanowienie w sprawie uzgodnienia warunków realizacji przedsięwzięcia w zakresie oddziaływania na obszar Natura 2000, w przypadku realizacji przedsięwzięcia, dla którego wymagane jest ich uzyskanie zgodnie z ustawą z dnia 3 października 2008 r. o udostępnianiu informacji o środowisku i jego ochronie, udziale społeczeństwa w ochronie środowiska oraz o ocenach oddziaływania na środowisko',
      '- Projekt planu wykonania nasadzeń zastępczych lub przesadzenia drzew lub krzewów, jeżeli są planowane, wykonany w formie rysunku, mapy lub projektu zagospodarowania terenu w przypadku inwestycji.',
      '- Oświadczenie o posiadanym prawie własności urządzeń, o których mowa w art.49 § 1 kodeksu cywilnego.',
      '- Rysunek, mapa albo wykonany przez projektanta posiadającego odpowiednie uprawnienia budowlane projekt zagospodarowania działki lub terenu w przypadku realizacji inwestycji, dla której jest on wymagany zgodnie z ustawą Prawo budowlane – określające usytuowanie drzewa lub krzewu w odniesieniu do granic nieruchomości i obiektów budowlanych istniejących lub projektowanych na tej nieruchomości',
    ],
    oplaty: [
      'Brak opłaty skarbowej za wydanie zezwolenia.',
      'W przypadkach i na zasadach określonych w ustawie o ochronie przyrody i aktach wykonawczych, pobiera się opłatę za usunięcie drzew lub krzewów. Jej wysokość ustalana jest indywidualnie.',
      'Opłata skarbowa od złożenia dokumentu stwierdzającego udzielenie pełnomocnictwa lub prokury albo jego odpisu, wypisu lub kopii wynosi 17 zł',
      'Dokument stwierdzający udzielenie pełnomocnictwa lub prokury oraz jego odpis, wypis lub kopia jest zwolniony z opłaty jeżeli mocodawcą jest podmiot określony w art. 7 pkt 1-5 ustawy o opłacie skarbowej.',
    ],
    tryb: 'Do Samorządowego Kolegium Odwoławczego za pośrednictwem organu, który wydał decyzję, w terminie 14 dni od dnia doręczenia decyzji',
    podstawa: podstawaUsuniecieDrzew,
    organ: 'wójt, burmistrz albo prezydent miasta, wojewódzki konserwator zabytków, Starosta właściwy ze względu na miejsce zamieszkania (wyłącznie w odniesieniu do nieruchomości będących własnością gminy)',
    rezultat: 'Rozpatrzenie wniosku i wydanie decyzji dot. zezwolenia na wycinkę drzew i krzewów.',
    etapy: [
      '1. Przyjęcie wniosku',
      '2. Weryfikacja wniosku',
      '3. Wydanie decyzji.',
    ],
    poziom_uwierzytelniania: ['Podpis kwalifikowany', 'Profil zaufany'],
    logowanie: 'TAK',
  },
  ZgloszenieUsunieciaDrzew: {
    title: 'Zgłoszenie zamiaru usunięcia drzew/a',
    dotyczy: 'Zgłoszenie składa właściciel nieruchomości lub pełnomocnik',
    czas: 'w ciągu 21 dni - oględziny drzewa, w ciągu 14 dni od oględzin - ewentualny sprzeciw organu administracji publicznej',
    dokumenty: [
      '- Wypełnione zgłoszenie + rysunek lub mapa'],
    oplaty: [
      'Brak',
    ],
    tryb: 'Odwołanie od decyzji o sprzeciwie w terminie 14 dni od daty jej otrzymania',
    podstawa: ['Ustawa z dnia 16 kwietnia 2004 r. o ochronie przyrody (Dz. U. z 2018 r., poz. 1614 z późn. zm., Art. 83f, ust. 4,)'],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: 'Milcząca zgoda organu lub decyzja o sprzeciwie',
    etapy: [
      '1. Złożenie wniosku przez właściciela gruntu, na którym rośnie drzewo',
      '2. Milcząca zgoda organu lub wniesienie sprzeciwu w postaci decyzji administracyjnej',
    ],
    poziom_uwierzytelniania: ['Podpis kwalifikowany', 'Profil zaufany'],
    logowanie: 'TAK',
  },
  WypisZMpzp: {
    title: 'Wypis z miejscowego planu zagospodarowania przestrzennego',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  WyrysZMpzp: {
    title: 'Wyrys z miejscowego planu zagospodarowania przestrzennego',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  WypisZeStudium: {
    title: 'Wypis ze studium uwarunkowań i kierunków zagospodarowania przestrzennego',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },  
  WyrysZeStudium: {
    title: 'Wyrys ze studium uwarunkowań i kierunków zagospodarowania przestrzennego',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  ZaswiadczenieEMUIA: {
    title: 'Wniosek o wydanie zaświadczenia o ustalonym numerze porządkowym budynku',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Dowód uiszczenia opłaty skarbowej.'],
    oplaty: ['17 zł'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  ZaswiadczenieStudium: {
    title: 'Wniosek o wydanie zaświadczenia ze studium uwarunkowań i kierunków zagospodarowania przestrzennego',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  ZezwolenieAlkohol: {
    title: 'Wniosek o wydanie zezwolenia na sprzedaż napojów alkoholowych',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  ZgloszeniePOS: {
    title: 'Zgłoszenie do ewidencji przydomowych oczyszczalni ścieków do 5 m2 na dobę',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  ZmianaCeluPublicznego: {
    title: 'Wniosek o zmianę decyzji o ustaleniu lokalizacji inwestycji celu publicznego',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  ZmianaSUIKZP: {
    title: 'Wniosek o zmianę studium uwarunkowań i kierunków zagospodarowania przestrzennego',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  ZmianaWarunkowZabudowy: {
    title: 'Wniosek o zmianę decyzji o warunkach zabudowy',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  decyzje_su: {
    title: 'Wniosek o wydanie decyzji środowiskowej',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  invest_contact: {
    title: 'List intencyjny inwestora',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  uproszczony_wypis: {
    title: 'Uproszczony wypis z miejscowego planu zagospodarowania przestrzennego',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  wmc: {
    title: 'Wniosek o miejsce na cmentarzu',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  wypis_i_wyrys: {
    title: 'Uproszczony wypis i wyrys z miejscowego planu zagospodarowania przestrzennego',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
  wziulicp: {
    title: 'Wniosek o wydanie decyzji o warunkach zabudowy lub decyzji o ustaleniu lokalizacji inwestycji celu publicznego',
    dotyczy: 'Nie określono.',
    czas: 'Nie określono.',
    dokumenty: ['Nie określono.'],
    oplaty: ['Nie określono.'],
    tryb: 'Nie określono.',
    podstawa: [],
    organ: 'Właściwy organ administracji publicznej np. Wójt, Burmistrz, Prezydent Miasta',
    rezultat: '',
    etapy: [],
    poziom_uwierzytelniania: [],
    logowanie: 'TAK',
  },
};



// WEBPACK FOOTER //
// src/routes/sprawy/Sprawy.js